import { API_MYEDUZZ } from 'settings';
import { apiServiceProxy } from 'v2/services/api-proxy';
import type { ApiServiceProxy } from 'v2/services/api-proxy';

class ProfileAccountService {
  constructor(private apiService: ApiServiceProxy) {}

  public async listAccounts(active?: boolean) {
    const params = active ? `?active=${active}` : '';
    return this.apiService.get(`${API_MYEDUZZ}/fundtransfers${params}`);
  }
}

export const profileAccountService = new ProfileAccountService(apiServiceProxy);
